export default __webpack_public_path__ + "static/media/pdf.91e233fd.png";